import { render, staticRenderFns } from "./new-nominations.vue?vue&type=template&id=d5623af8&"
import script from "./new-nominations.vue?vue&type=script&lang=js&"
export * from "./new-nominations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports